const firebaseConfig = {
    apiKey: "AIzaSyAaE4coOuhhaYcGzWsRc4vZPqd_gIwl_AU",
    authDomain: "react-firebase-authentic-fddb8.firebaseapp.com",
    projectId: "react-firebase-authentic-fddb8",
    storageBucket: "react-firebase-authentic-fddb8.appspot.com",
    messagingSenderId: "648755776980",
    appId: "1:648755776980:web:12d0aa8ac091a127009a41"
};
export default firebaseConfig;